import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import GoalForm from "./GoalForm";
import ObjectiveForm from "./ObjectiveForm";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import KeyResultForm from "./KeyResultForm";
import { GoGoal } from "react-icons/go";
import { api } from "../global/api";

const ButtonGroup = ({ onEditClick }) => {
  return (
    <div className="flex justify-end mt-4 gap-x-2">
      <button
        onClick={onEditClick}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      >
        Edit
      </button>
    </div>
  );
};

const SessionDetails = ({ data, message, isEditing, setIsEditing }) => {
  const [titleError, setTitleError] = useState(false);
  const [ownerError, setOwnerError] = useState(false);
  const [sessionError, setSessionError] = useState(false);
  const [parentError, setParentError] = useState(false);
  const [createGoalLoading, setCreateGoalLoading] = useState(false);
  const [goalcreated, setGoalCreated] = useState(null);
  const [objectivecreated, setObjectiveCreated] = useState(false);
  const [keyresultcreated, setKeyResultCreated] = useState(false);
  const [targetError, setTargetError] = useState(false);
  const [keyResultError, setKeyResultError] = useState(false);
  const [unitError, setUnitError] = useState(false);
  const [initialError, setInitialError] = useState(false);
  const [diffError, setDiffError] = useState(0);
  const Sessions = useSelector((state) => state.user?.sessionList);
  const [deadlineError, setDeadlineError] = useState(false);
  const userold = useSelector((state) => state.user);
  const currentUser = userold?.currentUser;
  const messageGoal = (message?.goals || [{}])[0];
  const sessionObj = Sessions?.find((item) => item?.value === message?.session);
  const owners = data?.owners?.map((item) => {
    return item?.id + " " + item?.type;
  });

  const [formData, setformData] = useState({
    session: sessionObj,
    title: messageGoal?.title,
    description: messageGoal?.description,
    owner: owners,
    // parent :
  });
  const onChangeTimePicker = (time, timeString) => {
    if (timeString) setDeadlineError(false);
    setformDataKey({ ...formDataKey, deadline: timeString });
  };

  function changeHandeler(event) {
    const { name, value } = event.target;
    if (name === "title") {
      //  setTitleError(false);

      if (value && value.length <= 70) {
        setTitleError(false);
      }
    }
    setformData((prevFormData) => {
      return {
        ...prevFormData,
        [name]: value,
      };
    });
  }

  const [formDataObj, setformDataObj] = useState({
    session: sessionObj,
    title: messageGoal?.children[0]?.objective_title,
    owner: owners,
    parent: "",
    // members: "",
    description: messageGoal?.children[0]?.objective_description,
  });
  const [okrData, setOkrData] = useState();

  function changeHandelerObj(event) {
    const { name, value } = event.target;
    if (name === "title") {
      //  setTitleError(false);

      if (value && value.length <= 70) {
        setTitleError(false);
      }
    }
    setformDataObj((prevFormData) => {
      return {
        ...prevFormData,
        [name]: value,
      };
    });
  }

  const [formDataKey, setformDataKey] = useState({
    session: sessionObj,
    title: messageGoal?.children[0]?.children[0]?.key_result_title,
    description: messageGoal?.children[0]?.children[0]?.key_result_description,
    unit: messageGoal?.children[0]?.children[0]?.unit,
    key_result_type: messageGoal?.children[0]?.children[0]?.key_result_type,
    initial_number: messageGoal?.children[0]?.children[0]?.initial_number,
    target_number: messageGoal?.children[0]?.children[0]?.target_number,
    owner: owners,
    deadline: messageGoal?.children[0]?.children[0]?.deadline,
    parent: "",
    // members: "",
    // description: "",
  });

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const saveData = async (event) => {
    let user_id = [];
    let team_id = [];
    let parent;
    let parent_type;
    if (!formData.title) {
      setTitleError(true);
      return;
    }
    if (!formData?.owner?.length) {
      setOwnerError(true);

      return;
    } else {
      formData?.owner?.forEach((item) => {
        let typeArr = item?.split(" ");
        if (typeArr[1] === "user") {
          user_id?.push(typeArr[0]);
        } else {
          team_id?.push(typeArr[0]);
        }
      });
    }
    if (formData?.parent_val) {
      const parentArr = formData?.parent_val?.split(" ");
      parent = parentArr[0];
      parent_type = parentArr[1];
    }

    try {
      setCreateGoalLoading(true);

      const currentEmployee = currentUser?.employees;
      let company_id;
      let login_user_id;
      if (currentEmployee && currentEmployee?.length) {
        company_id = currentEmployee[userold?.currentCompany]?.company_id;
        login_user_id = currentEmployee[userold?.currentCompany]?.user_id;
      }
      const session = formData?.session?.value ?? formData?.session;
      const result = await api.post("/goal/", {
        title: formData.title,
        user_id: user_id,
        team_id: team_id,
        description: formData.description,
        company_id: company_id,
        session: session,
        parent: parent,
        parent_type: parent_type,
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "goal_created",
        message: "Goal created succesfully!.",
        id: result?.data?.goal_id,
        title: result?.data?.title,
        description: result?.data?.description,
        event_ts: new Date(Date.now()).toLocaleString(),
      });
      setGoalCreated(result?.data?.goal_id);
      toast.success("Goal Created Succesfully!.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (err) {
      console.log(err);
      toast.error("Try Again", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setCreateGoalLoading(false);
      setIsEditing(false);
    }
  };

  const saveDataObj = async (event) => {
    let user_id = [];
    let team_id = [];
    let parentGoal;
    if (!formDataObj.title) {
      return;
    }

    if (formDataObj?.owner?.length) {
      formDataObj?.owner?.forEach((item) => {
        let typeArr = item.split(" ");
        if (typeArr[1] === "user") {
          user_id.push(typeArr[0]);
        } else {
          team_id.push(typeArr[0]);
        }
      });
    } else {
      setOwnerError(true);
      return;
    }
    if (!formDataObj?.session === null || !formData?.session) {
      setSessionError(true);
      return;
    }
    parentGoal = formData?.parent_val || goalcreated;

    setCreateGoalLoading(true);
    try {
      const currentEmployee = currentUser?.employees;
      let company_id;
      let login_user_id;
      if (currentEmployee && currentEmployee?.length) {
        company_id = currentEmployee[userold?.currentCompany]?.company_id;
        login_user_id = currentEmployee[userold?.currentCompany]?.user_id;
      }
      const session = formData?.session?.value ?? formData?.session;
      const result = await api.post("/okr/", {
        session: session,
        parent: true,
        title: formDataObj.title,
        user_id: user_id,
        team_id: team_id,
        company_id: company_id,
        goal_id: parentGoal,
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "okr_created",
        message: "Objective created succesfully!.",
        id: result?.data?.okr_id,
        title: result?.data?.title,
        description: result?.data?.description,
        event_ts: new Date(Date.now()).toLocaleString(),
      });
      setObjectiveCreated(result?.data?.okr_id);
      toast.success("Objective Created Succesfully!.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (err) {
      console.log(err);
      toast.error("Try Again", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      // handleEdit();
      setIsEditing(false);
      setCreateGoalLoading(false);
    }
  };

  const saveDataKey = async (event) => {
    event.preventDefault();
    let okr_id = objectivecreated;
    let user_id = [];
    let team_id = [];

    if (formDataKey?.title === "") {
      setTitleError(true);
      return;
    }
    if (!formDataKey?.owner) {
      setOwnerError(true);
      return;
    }
    if (formDataKey?.deadline === "") {
      setDeadlineError(true);
      return;
    }
    if (
      formDataKey?.key_result_type === "" ||
      formDataKey?.key_result_type === ""
    ) {
      setKeyResultError(true);
      return;
    }
    if (!formDataKey?.unit || formDataKey?.unit === "") {
      setUnitError(true);
      return;
    }
    if (formDataKey?.target_number === "") {
      setTargetError(true);
      return;
    }
    if (formDataKey?.initial_number === "") {
      setInitialError(true);
      return;
    }

    if (formDataKey?.owner?.length) {
      formDataKey?.owner?.forEach((item) => {
        let typeArr = item.split(" ");
        if (typeArr[1] === "user") {
          user_id.push(typeArr[0]);
        } else {
          team_id.push(typeArr[0]);
        }
      });
    } else {
      setOwnerError(true);
      return;
    }

    if (formDataKey?.deadline === "") {
      setDeadlineError(true);
      return;
    }
    if (diffError) {
      return;
    }

    setCreateGoalLoading(true);
    try {
      const result = await api.post("/key_results/", {
        title: formDataKey.title,
        key_result_type: formDataKey.key_result_type,
        unit: formDataKey.unit,
        target_number: formDataKey.target_number,
        initial_number: formDataKey.initial_number,
        description: formDataKey.description,
        deadline: formDataKey.deadline,
        okr_id: okr_id || objectivecreated,
        company_id: currentUser?.employees[userold?.currentCompany]?.company_id,
        user_ownwer_id:
          currentUser?.employees[userold?.currentCompany]?.user_id,
        user_id: user_id,
        team_id: team_id,
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "key_result_created",
        message: "Key Result created succesfully!.",
        id: result?.data?.key_id,
        title: result?.data?.title,
        description: result?.data?.description,
        event_ts: new Date(Date.now()).toLocaleString(),
      });
      setKeyResultCreated(true);
      toast.success("Key Result Created Succesfully!.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (err) {
      console.log(err);
      toast.error("Try Again", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setCreateGoalLoading(false);
      setIsEditing(false);
    }
  };

  return (
    <div className="w-full">
      {isEditing ? (
        <div>
          {!goalcreated && (
            <GoalForm
              formData={formData}
              setformData={setformData}
              changeHandler={changeHandeler}
              titleError={titleError}
              ownerError={ownerError}
              sessionError={sessionError}
              setTitleError={setTitleError}
              setOwnerError={setOwnerError}
              setSessionError={setSessionError}
              handleEditClick={handleEditClick}
              saveData={saveData}
              loading={createGoalLoading}
            />
          )}
          {goalcreated && !objectivecreated && (
            <ObjectiveForm
              formData={formDataObj}
              setformData={setformDataObj}
              changeHandeler={changeHandelerObj}
              titleError={titleError}
              ownerError={ownerError}
              sessionError={sessionError}
              setTitleError={setTitleError}
              setOwnerError={setOwnerError}
              setSessionError={setSessionError}
              parentError={parentError}
              setParentError={setParentError}
              handleEditClick={handleEditClick}
              saveData={saveDataObj}
              okrData={okrData}
              setOkrData={setOkrData}
              goalcreated={goalcreated}
              loading={createGoalLoading}
            />
          )}
          {goalcreated && objectivecreated && !keyresultcreated && (
            <KeyResultForm
              formData={formDataKey}
              saveData={saveDataKey}
              owners={owners}
              titleError={titleError}
              setTitleError={setTitleError}
              targetError={targetError}
              setTargetError={setTargetError}
              initialError={initialError}
              setInitialError={setInitialError}
              setKeyResultError={setKeyResultError}
              keyResultError={keyResultError}
              setUnitError={setUnitError}
              unitError={unitError}
              deadlineError={deadlineError}
              setDeadlineError={setDeadlineError}
              //  changeHandeler={changeHandler}
              setformData={setformDataKey}
              onChangeTimePicker={onChangeTimePicker}
              setDiffError={setDiffError}
              diffError={diffError}
              setOwnerError={setOwnerError}
              ownerError={ownerError}
              loading={createGoalLoading}
            />
          )}
        </div>
      ) : (
        <div>
          <div>
            <div className="flex gap-x-2">
              <button
                className="rounded p-1"
                style={{
                  background:
                    "linear-gradient(140.34deg, rgba(252, 8, 0, 0.29) 9.12%, rgba(253, 64, 64, 0) 92.07%)",
                }}
              >
                <GoGoal
                  className="text-md"
                  style={{
                    color: "#B91C1C",
                    width: "18px",
                    height: "18px",
                  }}
                />
              </button>
              <strong className="flex items-center">Goal</strong>
            </div>
            <p>
              {" "}
              <ArrowRightIcon /> Title: {formData?.title}
            </p>
            <p>
              {" "}
              <ArrowRightIcon /> Description: {formData?.description}
            </p>
            {/* <p>Parent: {formData?.parent_val}</p> */}
            {!goalcreated && userold?.roleAccess?.Goals?.Create && (
              <ButtonGroup onEditClick={handleEditClick} />
            )}

            {messageGoal?.children?.map((child, index) => (
              <div key={index} className="mt-2 ml-2">
                <div className="flex gap-x-2">
                  <button>
                    <img
                      src="/assets/images/objective.svg"
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </button>
                  <strong className="flex items-center">Objective</strong>
                </div>
                <p>
                  {" "}
                  <ArrowRightIcon />
                  Title:{" "}
                  {formDataObj?.title ||
                    child?.objective_title ||
                    "No title available"}
                </p>
                <p>
                  {" "}
                  <ArrowRightIcon />
                  Description:{" "}
                  {formDataObj?.description ||
                    child?.objective_description ||
                    "No description available"}
                </p>
                {goalcreated &&
                  !objectivecreated &&
                  userold?.roleAccess?.Objectives?.Create && (
                    <ButtonGroup onEditClick={handleEditClick} />
                  )}
                {child?.children?.map((grandchild, index) => (
                  <div key={index} className="mt-2 ml-4">
                    <p className="flex gap-x-2">
                      <button>
                        <img
                          src="/assets/images/keyresults.svg"
                          style={{
                            width: "20px",
                            height: "20px",
                          }}
                        />
                      </button>
                      <strong className="flex items-center">Key Result</strong>
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Title:{" "}
                      {formDataKey?.title ||
                        grandchild?.key_result_title ||
                        "No title available"}
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Description:{" "}
                      {formDataKey?.description ||
                        grandchild?.key_result_description ||
                        "No description available"}
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Unit: {formDataKey?.unit || grandchild?.unit || "N/A"}
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Type:{" "}
                      {formDataKey?.key_result_type ||
                        grandchild?.key_result_type ||
                        "N/A"}
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Initial Number:{" "}
                      {formDataKey?.initial_number ||
                        grandchild?.initial_number ||
                        "0"}
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Target Number:{" "}
                      {formDataKey?.target_number ||
                        grandchild?.target_number ||
                        "0"}
                    </p>
                    <p>
                      <ArrowRightIcon />
                      Deadline:{" "}
                      {formDataKey?.deadline ||
                        grandchild?.deadline ||
                        "No deadline"}
                    </p>
                  </div>
                ))}
                {goalcreated &&
                  objectivecreated &&
                  !keyresultcreated &&
                  userold?.roleAccess?.["Key-Results"]?.Create && (
                    <ButtonGroup onEditClick={handleEditClick} />
                  )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionDetails; 